/**
 * TanStack Query hooks for `self-signup-form-for-affiliates-brandable`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	selfSignupFormForAffiliatesBrandableQueryKeys,
	type CreateSelfSignupFormForAffiliatesBrandableBody,
	type ListSelfSignupFormForAffiliatesBrandableResponse,
	type SelfSignupFormForAffiliatesBrandableRow,
} from "./api";

export function useSelfSignupFormForAffiliatesBrandableList(): UseQueryResult<ListSelfSignupFormForAffiliatesBrandableResponse, Error> {
	return useQuery({
		queryKey: selfSignupFormForAffiliatesBrandableQueryKeys.list(),
		queryFn: list,
	});
}

export function useSelfSignupFormForAffiliatesBrandableCreate(): UseMutationResult<SelfSignupFormForAffiliatesBrandableRow, Error, CreateSelfSignupFormForAffiliatesBrandableBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: selfSignupFormForAffiliatesBrandableQueryKeys.all });
		},
	});
}

export function useSelfSignupFormForAffiliatesBrandableDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: selfSignupFormForAffiliatesBrandableQueryKeys.all });
		},
	});
}
